import type { To } from 'react-router-dom';

import FuturesClientCategorisationLayout from '@/features/futures/layouts/client-categorisation';
import ServicesAgreement from '@/features/services-agreement/components/agreement';

type FuturesServicesAgreementPageProps = {
  next?: To;
};

const FuturesServicesAgreementPage = ({ next = '/futures/verification' }: FuturesServicesAgreementPageProps) => {
  return (
    <FuturesClientCategorisationLayout fill>
      <ServicesAgreement next={next} />
    </FuturesClientCategorisationLayout>
  );
};
FuturesServicesAgreementPage.displayName = 'FuturesServicesAgreementPage';

export default FuturesServicesAgreementPage;
